"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorldpayMetaDataFields = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const getWorldpayMetaDataFields = (transaction) => {
    if (transaction.metadata === null) {
        return;
    }
    if (homi_shared_1.PaymentTypeIds.worldpay === transaction.paymentTypeId) {
        const metaData = JSON.parse(transaction.metadata);
        return metaData;
    }
};
exports.getWorldpayMetaDataFields = getWorldpayMetaDataFields;
//# sourceMappingURL=getMetaDataFields.js.map